import { AxiosResponse } from 'axios';
import { OrderProductGetDTO, PalletsPerStatusDto } from 'svila-common';
import { API_URL } from '../../utils/constants';
import request from '../request';

export default {
  get: async (id) => {
    return request(`${API_URL}/orders/order-products/${id}`, 'get', {}, {});
  },
  optest: async (id) => {
    return request(`${API_URL}/orders/order-products/optest/${id}`, 'get');
  },
  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/orders/order-products/${id}`, 'put', body, {});
  },
  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/orders/order-products/`, 'post', body, {});
  },
  delete: async (id) => {
    return request(`${API_URL}/orders/order-products/${id}`, 'delete', {}, {});
  },
  getForOrder: async (id: string): Promise<AxiosResponse<OrderProductGetDTO[]>> => {
    return request(`${API_URL}/orders/order-products/for-order-id/${id}`, 'get');
  },
  getCalculatorList: async (id) => {
    return request(`${API_URL}/orders/order-products/calculator/get-list/${id}`, 'post', {}, {});
  },
  getVisualizationList: async (id) => {
    return request(`${API_URL}/orders/order-products/calculator/get-pallet-data/${id}`, 'post', {}, {});
  },
  getTotals: async (id) => {
    return request(`${API_URL}/orders/order-products/calculator/get-totals-data/${id}`, 'post');
  },
  updateCalculator: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/orders/order-products/calculator/update/${id}`, 'post', body, {});
  },
  visualizeGrid: async (id) => {
    const body = JSON.stringify({
      skip: 0,
      take: 50,
    });
    return request(`${API_URL}/orders/order-products/calculator/visualize-grid/${id}`, 'post', body);
  },
  importOrderProducts: async (fileId: string, orderId: string): Promise<AxiosResponse<OrderProductGetDTO[]>> => {
    return request(`${API_URL}/orders/order-products/import-order-products/${fileId}/${orderId}`, 'post');
  },
  getPalletCountForStatuses: async (orderId: string): Promise<AxiosResponse<PalletsPerStatusDto>> => {
    return request(`${API_URL}/orders/order-products/get-pallets-per-status/${orderId}`, 'get');
  },
  removeCu: async () => {
    return request(`${API_URL}/orders/order-products/remove-cu`, 'put');
  },
};
